import { ACCESS_ORIGINS, AccessOrigin } from '../types/branch';

export const getBranchEventTag = (branch: AccessOrigin) => `OrigemAcesso_${branch}`;

export const isValidBranch = (value: string): value is AccessOrigin =>
  (ACCESS_ORIGINS as readonly string[]).includes(value);
